import {
  actionCreator,
  persistentReducedStream,
  reducer,
} from '@ardoq/rxbeach';

export const currentUserSettled = actionCreator(
  '[presentation] CURRENT_USER_SETTLED'
);

const settle = (): boolean => true;

const defaultState = false;

const reducers = [reducer(currentUserSettled, settle)];

/**
 * `currentUser$` is null both for an anonymous viewer and for a viewer whose
 * user request is still in flight. This says which of the two it is: it turns
 * true once the presentation viewer has finished asking who is watching,
 * signed in or not.
 */
export const currentUserSettled$ = persistentReducedStream(
  'currentUserSettled$',
  defaultState,
  reducers
);
